import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '2px solid #d9d9d9',
    paddingBlock: 8,
    lineHeighteight: '30px',
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'flex-start',
    flexDirection: 'row',
    gap: 8,
    '& > svg': {
      margin: 0,
    },
  },
  title: {
    display: 'flex',
    gap: 8,
    '& > p': {
      margin: 0,
    },
  },
  unity: {
    backgroundColor: '#000000',
    color: '#ffffff',
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '15px',
    lineHeight: '20px',
  },
  pro: {
    fontSize: '12px',
    padding: '2px 8px',
    border: '2px solid #d9d9d9',
    borderRadius: '15px',
    lineHeight: '20px',
  },
  formContainer: {
    margin: 'auto',
    maxWidth: 720,
    paddingTop: 48,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
}));

export default useStyles;
